/**
 * AI CONTEXT
 * Purpose: current user profile summary + personal evaluations list.
 * Key deps: UserContext, UserEvaluationsList.
 * Referenced by: App route ROUTES.PROFILE.
 * Importance: self-service user visibility page.
 * Refactor: add loading/skeleton state when currentUser is not ready.
 */
import { Card, Typography } from "antd"

import Flex from "#blocks/Flex"
import Page from "#blocks/Page"
import { useThemeContext } from "#contexts/ThemeContextProvider"
import { useUserContext } from "#contexts/UserContextProvider"
import { camelToWords } from "#utils/textFormatters"

import UserEvaluationsList from "./forms/AddUser/UserEvaluationsList"

const { Text, Title } = Typography

const UserPersonalProfile = () => {
  const { currentUser } = useUserContext()
  const { body1 } = useThemeContext()

  return (
    <Page>
      <Flex
        col
        gap={24}
        style={{
          maxWidth: 800,
          width: "100%",
          padding: 40,
          marginTop: 40,
        }}
      >
        <Card style={{ background: body1 }}>
          <Title level={3} style={{ margin: 0 }}>
            {currentUser?.name}
          </Title>
          <Text type="secondary">{camelToWords(currentUser?.role)}</Text>
        </Card>

        <UserEvaluationsList userId={currentUser?.id} />
      </Flex>
    </Page>
  )
}

export default UserPersonalProfile
